import cn from 'classnames';
import React from 'react';

interface PassageProps {
    id?: string;
    heading?: string;
    className?: string;
    /** Passages are separated by a single hairline, not by colour. */
    rule?: boolean;
}

export default function Passage({ id, heading, className, rule = true, children }: React.PropsWithChildren<PassageProps>) {
    return (
        <section id={id} className={cn('scroll-mt-16', className)}>
            {rule && <div className="rule mb-14 mt-14 md:mb-20 md:mt-20" aria-hidden="true" />}
            {/* Headings never animate in. They are wayfinding: if the observer does
                not fire for any reason, the label telling you where you are is gone. */}
            {heading && <h2 className="t-label mb-9 text-muted">{heading}</h2>}
            {children}
        </section>
    );
}
